import FlagAssigneeModal from './FlagAssigneeModal';

export default FlagAssigneeModal;
